/**
 * Feature Flag Manager Constants
 * Shared localStorage keys for feature flag overrides
 */

export const FORCE_ON_KEY = 'ui.privs.forcedOnFlags';
export const FORCE_OFF_KEY = 'ui.privs.forcedOffFlags';
export const CUSTOM_FLAGS_KEY = 'ui.privs.customFlags';
export const FF_MODE_KEY = 'ui.featureFlagMode';
